import React from 'react';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import MaterialRadioGroup from '@material-ui/core/RadioGroup';
import { Tooltip } from '@totango-app-team/ui-shared-components';
import PropTypes from 'prop-types';

import FormControl from '../form-control/form-control';

const RadioOptionLabel = ({
	value,
	className,
	color,
	size,
	label,
	labelComponent,
	disabled,
	labelPlacement,
}) => (
	<FormControlLabel
		className={className}
		classes={{ label: 'group-option-label' }}
		value={value}
		control={
			<Radio
				color={color || 'primary'}
				classes={{ root: `${className}-radio` }}
				size={size || 'medium'}
			/>
		}
		label={labelComponent || label}
		disabled={!!disabled || disabled}
		labelPlacement={labelPlacement || 'end'}
	/>
);

const RadioGroup = props => {
	const { options, fullWidth, row, className, disabled } = props;
	const InputComponent = (
		<MaterialRadioGroup {...props} style={row && { flexWrap: 'nowrap' }}>
			{options.map(option => {
				const data = { ...option, disabled: !!option.disabled || disabled };
				if (option.tooltip) {
					data.labelComponent = (
						<Tooltip title={option.tooltip}>
							{option.labelComponent ? option.labelComponent : <span>{option.label}</span>}
						</Tooltip>
					);
				}
				return <RadioOptionLabel {...data} key={option.value} />;
			})}
		</MaterialRadioGroup>
	);

	return (
		<FormControl className={className} inputComponent={InputComponent} fullWidth={fullWidth} />
	);
};

RadioGroup.propTypes = {
	options: PropTypes.arrayOf(
		PropTypes.shape({
			value: PropTypes.any.isRequired,
			label: PropTypes.string.isRequired,
			color: PropTypes.string,
			size: PropTypes.string,
			disabled: PropTypes.bool,
			labelComponent: PropTypes.element,
			tooltip: PropTypes.string,
		}),
	).isRequired,
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
};

export default RadioGroup;
